import React from 'react';
import type {
    OperationSummaryData,
    OutcomeSummaryData,
    RuleSummaryData,
} from '../../../../../../types/page';
import OperationSummary from './OperationSummary';
import OutcomeSummary from './OutcomeSummary';
import RuleSummary from './RuleSummary';

interface Props {
    comparisonType: string | null;
    ruleData: RuleSummaryData[];
    operationData: OperationSummaryData[];
    // Null for a condition that executes its operations rather than progressing the flow on an outcome.
    outcomeData?: OutcomeSummaryData | null;
}

const ConditionSummary = ({ comparisonType, ruleData, operationData, outcomeData }: Props) => {
    const ruleSummaries = ruleData.map((rule, index) => {
        return index >= 1 ? (
            // biome-ignore lint/suspicious/noArrayIndexKey: No alternative to index
            <React.Fragment key={index}>
                <span className="summary-keyword"> {comparisonType || 'AND'}</span>{' '}
                <RuleSummary {...rule} />
            </React.Fragment>
        ) : (
            // biome-ignore lint/suspicious/noArrayIndexKey: No alternative to index
            <RuleSummary key={index} {...rule} />
        );
    });

    const operationSummaries = operationData.map((operation, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: No alternative to index
        <OperationSummary key={index} {...operation} />
    ));

    return (
        <div className="formatted-condition-summary" data-testid="formatted-condition-summary">
            {ruleSummaries}
            <span className="summary-keyword">THEN</span>
            <br />
            {/* A condition either progresses the flow on an outcome or executes its operations, never both. */}
            {outcomeData ? <OutcomeSummary {...outcomeData} /> : operationSummaries}
        </div>
    );
};

export default ConditionSummary;
